var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video-js vjs-default-skin",attrs:{"id":"my-video","controls":"","height":_vm.height,"width":_vm.width}},[_c('source',{attrs:{"src":_vm.videoSource,"type":"application/x-mpegURL"}})])}
var staticRenderFns = []

export { render, staticRenderFns }